import { client } from '@/app/Providers/ApolloContext'
import {
  CodeServiceSendMessageToSlackDocument,
  CodeServiceSendMessageToSlackMutation,
  CodeServiceSendMessageToSlackMutationVariables,
} from '@/graphql/generated/graphql'
import { getUserEmail } from '@/hooks/useAuth/zustand'
import { trackHeap } from '@/services/analytics'

let lastNotificationTime: number | null = null

export async function sendIsolatedErrorMessageSlackNotification(
  propMessage: string,
) {
  const name = 'Erro inesperado de frontend'
  // Check if notification was sent in the last 2 minutes
  const TWO_MINUTES_IN_MS = 120000
  if (
    lastNotificationTime &&
    Date.now() - lastNotificationTime < TWO_MINUTES_IN_MS
  ) {
    return
  }
  // Update last notification time
  const user = getUserEmail()
  const message = `Registro de erro para email: ${user} no url ${window.location.href}. ${propMessage}.`
  lastNotificationTime = Date.now()
  trackHeap({ name, properties: { message } })

  await client.mutate<CodeServiceSendMessageToSlackMutation>({
    mutation: CodeServiceSendMessageToSlackDocument,
    variables: {
      message,
    } satisfies CodeServiceSendMessageToSlackMutationVariables,
  })

  // To track in sentry
  throw new Error(message)
}
